"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Price = void 0;
const DOM_1 = require("./DOM");
var Price;
(function (Price) {
    class Config {
        static priceLoaderClassName = "priceLoader";
        static priceDataName = "price";
        static languageDataName = "language";
    }
    Price.Config = Config;
    class Initializer {
        language;
        constructor() {
            this.language = DOM_1.DOM.Parser.getDataByNameFromElement(Config.languageDataName, DOM_1.DOM.Parser.getBodyElement());
        }
        initializePrices(container) {
            const loaders = DOM_1.DOM.Parser.getHtmlElements(Config.priceLoaderClassName, container, true);
            for (let i = 0; i < loaders.length; i++) {
                const loader = loaders[i];
                const price = JSON.parse(DOM_1.DOM.Parser.getDataByNameFromElement(Config.priceDataName, loader));
                loader.innerText = this.getPriceAmountStringFromPriceObject(price, false, false);
            }
        }
        getPriceAmountStringFromPriceObject(price, withoutCurrency, changeMode, showZero = false) {
            let amountString = this.getAmountFormatter().format(price.price);
            if (changeMode) {
                amountString = price.price > 0
                    ? '+' + amountString
                    : (price.price === 0 && !showZero ? '' : amountString);
            }
            return withoutCurrency || (changeMode && price.price === 0) ? amountString : amountString + ' ' + price.currency;
        }
        getAmountFormatter() {
            return new Intl.NumberFormat(this.language === 'cs' ? 'cs-CZ' : 'en-US', {
                minimumFractionDigits: 2
            });
        }
    }
    Price.Initializer = Initializer;
})(Price || (exports.Price = Price = {}));
